// Footer.js
import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import './../App.css';
import { APP_VERSION_LABEL } from '../version';
import { SMART_COLORS as C } from '../theme/smartStableTheme';

const Footer = ({ sidebarExpanded }) => (
  <Box
    className={
      sidebarExpanded
        ? 'sidebar-expanded footer-container'
        : 'sidebar-collapsed footer-container'
    }
    sx={{
      backgroundColor: C.paper,
      py: 2,
      px: 2,
      mt: 'auto',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 1.5,
      flexWrap: 'wrap',
      textAlign: 'center',
    }}
  >
    <Typography variant="body2" align="center">
      Developed by <strong>Smart Stable</strong> — © Nudrah Stud 2025
    </Typography>
    <Chip
      label={APP_VERSION_LABEL}
      size="small"
      sx={{
        fontWeight: 700,
        // توكنات الثيم بدل الألوان الثابتة (تتبع المجموعة الفعّالة؛ قيم ندرة = السابقة).
        bgcolor: C.sidebarAccent,
        color: C.surface,
        height: 22,
      }}
    />
  </Box>
);

export default Footer;
